import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS

export const grey = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

export const secondary = {
  lighter: "#C4CDD5",
  light: "#919EAB",
  main: "#637381",
  dark: "#454F5B",
  darker: "#212B36",
  contrastText: "#FFFFFF",
};

export const primary = {
  lighter: "#E3F2FD",
  light: "#90CAF9",
  main: "#2196F3",
  dark: "#1565C0",
  darker: "#0D47A1",
  contrastText: "#FFFFFF",
};

export const info = {
  lighter: "#E0F7FA",
  light: "#4DD0E1",
  main: "#00BCD4",
  dark: "#0097A7",
  darker: "#006064",
  contrastText: "#FFFFFF",
};

export const success = {
  lighter: "#E8F5E8",
  light: "#81C784",
  main: "#4CAF50",
  dark: "#388E3C",
  darker: "#1B5E20",
  contrastText: "#FFFFFF",
};

export const warning = {
  lighter: "#FFF8E1",
  light: "#FFD54F",
  main: "#FF9800",
  dark: "#F57C00",
  darker: "#E65100",
  contrastText: "#000000",
};

export const error = {
  lighter: "#FFEBEE",
  light: "#EF5350",
  main: "#F44336",
  dark: "#D32F2F",
  darker: "#B71C1C",
  contrastText: "#FFFFFF",
};

export const common = {
  black: "#000000",
  white: "#FFFFFF",
};

export const action = {
  hover: alpha(grey[100], 0.08),
  selected: alpha(grey[100], 0.12),
  disabled: alpha(grey[500], 0.6),
  disabledBackground: alpha(grey[500], 0.12),
  focus: alpha(grey[100], 0.12),
  hoverOpacity: 0.08,
  disabledOpacity: 0.38,
};

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  divider: alpha(grey[100], 0.12),
  action,
};

// ----------------------------------------------------------------------

export function palette() {
  return {
    ...base,
    mode: "dark",
    text: {
      primary: grey[100],
      secondary: grey[400],
      disabled: alpha(grey[500], 0.6),
    },
    background: {
      paper: "#1A1A1A",
      default: "#121212",
      neutral: "#1E1E1E",
    },
    action: {
      ...base.action,
      active: grey[300],
      hover: alpha(grey[100], 0.08),
      selected: alpha(primary.main, 0.12),
      disabled: alpha(grey[500], 0.26),
      disabledBackground: alpha(grey[500], 0.12),
      focus: alpha(primary.main, 0.12),
    },
    divider: alpha(grey[100], 0.12),
  };
}
